import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cm-ticketing-a4-default-1',
    templateUrl: './ticket-template-a4-default-1.component.html',
    styleUrls: ['./ticket-template-a4-default-1.component.scss', '../../shared/shared-presets.scss'],
    standalone: false
})
export class TicketTemplateA4Default1Component implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
